import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./BlogPostsSection.css";
import { useNavigate, Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BlogPostsSection = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fallbackImage = require("../assets/logo1.png");

  const getImage = (url) => {
    if (!url || url.trim() === "") {
      return fallbackImage;
    }
    return url;
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(
          "https://aikyam-server-supabaseoff.onrender.com/api/blogs"
        );
        if (!res.ok) throw new Error("Failed to fetch blogs");
        const data = await res.json();

        const sorted = data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        setBlogs(sorted);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  if (loading) {
    return (
      <div className="bps-loading-box">
        <div className="bps-loading-spinner"></div>
        <p>Loading blogs...</p>
      </div>
    );
  }

  if (error || blogs.length === 0) {
    return (
      <div className="bps-error-page">
        <img
          src="/SVG/eror.svg"
          alt="Error"
          className="bps-error-image"
        />
        <Link to="/" className="bps-error-home-button">
          Go to Home Page
        </Link>
      </div>
    );
  }

  const slides = [];
  for (let i = 0; i < blogs.length; i += 5) {
    slides.push({
      featured: blogs[i],
      others: blogs.slice(i + 1, i + 5),
    });
  }

  return (
    <section className="blog-section">
      <div className="background-wrapper">
        <div className="content-wrapper">
          <h2>
            Aikyam <span className="highlight-text">Blog Posts</span>
          </h2>
          <p className="sub">
            Discover Essential Tips To Maximize Your Workout Results And Reach
            Your Fitness Goals Faster.
          </p>

          <div className="slider-container">
            <Slider {...settings}>
              {slides.map((slide, idx) => (
                <div key={idx} className="full-slide">
                  <div className="slide-content">
                    <div
                      className="featured-blog"
                      onClick={() => navigate("/blog")}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={getImage(slide.featured?.image)}
                        alt={slide.featured?.title}
                      />
                      <div className="blog-content">
                        <h4>{slide.featured?.title}</h4>
                        <p className="meta">
                          ⏱ {slide.featured?.duration || 3} Min. Read &nbsp; |
                          &nbsp; 📂 {slide.featured?.category || "General"}
                        </p>
                        <button className="learn-more-btn">
                          Learn More →
                        </button>
                      </div>
                    </div>

                    <div className="small-blogs">
                      {slide.others.map((post, index) => (
                        <div
                          className="small-blog-card"
                          key={index}
                          onClick={() => navigate("/blog")}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={getImage(post?.image)}
                            alt={post?.title}
                          />
                          <div className="blog-content">
                            <h4>{post?.title}</h4>
                            <p className="meta">
                              📂 {post?.category || "General"}
                            </p>
                            <button className="learn-more-btn">
                              Learn More →
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="view-all-container">
            <button
              className="view-all-btn"
              onClick={() => navigate("/blog")}
            >
              <span className="view-text">View All</span>
              <span className="view-arrow">&gt;</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogPostsSection;
